import type { QueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { throwIfProblemDetails } from "@/hooks/useOrganizations";
import type { UpdateOrganizationRequest } from "@/types/generated/cms.generated";

/**
 * The partial organisation save (cms-org-core, OP-D14): `PUT organizations/{id}` with only the keys
 * a section changed — a key not sent keeps its stored value, `null` clears an optional field.
 * A format error arrives as a bare ValidationProblemDetails, which the parser passes through.
 */
export async function putOrganization(organizationId: string, body: UpdateOrganizationRequest): Promise<unknown> {
  const response = await apiRequest("PUT", `/organizations/${organizationId}`, body);
  throwIfProblemDetails(response);
  return response;
}

/** Re-reads the company (page + list) after a save. */
export function invalidateOrganization(queryClient: QueryClient, organizationId: string) {
  queryClient.invalidateQueries({ queryKey: [`/organizations/${organizationId}`] });
  queryClient.invalidateQueries({ queryKey: ["/organizations"] });
}

/** A trimmed text field as the partial save sends it: blank ⇒ `null` (clears it). */
export const textOrNull = (value: string): string | null => value.trim() || null;
